import { lazy, Suspense, type ReactNode } from 'react';
import { createBrowserRouter, Link } from 'react-router-dom';
import { variantesBouton } from '@/components/ui/button';
import { ChargementBloc, EtatVide } from '@/components/ui/feedback';
import { AppShell } from '@/layouts/AppShell';
import { ConnexionPage } from '@/features/auth/ConnexionPage';
import { RequireAuth } from '@/features/auth/RequireAuth';
import { DashboardPage } from '@/features/dashboard/DashboardPage';
import { CommandesPage } from '@/features/commandes/CommandesPage';
import { ClientsPage } from '@/features/clients/ClientsPage';
import { ClientDetailPage } from '@/features/clients/ClientDetailPage';
import { StockPage } from '@/features/stock/StockPage';
import { VentesPage } from '@/features/ventes/VentesPage';
import { CaissePage } from '@/features/caisse/CaissePage';
import { FacturesPage } from '@/features/factures/FacturesPage';
import { FactureEditPage } from '@/features/factures/FactureEditPage';

// L'import Excel embarque SheetJS : chargé à la demande, il ne pèse pas sur le
// démarrage des autres écrans.
const ImportPage = lazy(() =>
  import('@/features/import/ImportPage').then((m) => ({ default: m.ImportPage })),
);

function Differe({ children }: { children: ReactNode }) {
  return <Suspense fallback={<ChargementBloc />}>{children}</Suspense>;
}

function Introuvable() {
  return (
    <EtatVide
      titre="Page introuvable"
      description="Le lien suivi ne correspond à aucun écran de l'application."
      action={
        <Link to="/" className={variantesBouton({ variant: 'primary' })}>
          Retour au tableau de bord
        </Link>
      }
    />
  );
}

export const routeur = createBrowserRouter([
  // Déclarée avant la racine : c'est le seul écran accessible sans session.
  { path: '/connexion', element: <ConnexionPage /> },
  {
    path: '/',
    element: (
      <RequireAuth>
        <AppShell />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <DashboardPage /> },
      { path: 'commandes', element: <CommandesPage /> },
      { path: 'ventes', element: <VentesPage /> },
      { path: 'caisse', element: <CaissePage /> },
      { path: 'clients', element: <ClientsPage /> },
      { path: 'clients/:id', element: <ClientDetailPage /> },
      { path: 'stock', element: <StockPage /> },
      { path: 'factures', element: <FacturesPage /> },
      { path: 'factures/nouvelle', element: <FactureEditPage /> },
      { path: 'factures/:id', element: <FactureEditPage /> },
      {
        path: 'import',
        element: (
          <Differe>
            <ImportPage />
          </Differe>
        ),
      },
      { path: '*', element: <Introuvable /> },
    ],
  },
]);
